import useGlobalContext from './useGlobalContext'
import { useMemo } from 'react'
import { WorkflowDto } from '../components/TagPicker/WorkflowPicker'

type ReturnProps = {
    loaded: boolean
    workflows: WorkflowDto[]
    getWorkflowById: (id: string) => WorkflowDto
}

export default function useWorkflows(): ReturnProps {
    const { entities, loaded } = useGlobalContext('workflows')

    const workflows: WorkflowDto[] = useMemo(
        () => entities?.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())) || [],
        [entities],
    )

    const getWorkflowById: ReturnProps['getWorkflowById'] = (id: string): WorkflowDto =>
        entities.find(user => user.id === id)

    return { loaded, workflows, getWorkflowById }
}
